import {ApplicationInsights, IApplicationInsights} from '@microsoft/applicationinsights-web';

type AppInsightsConfig = {
    analyticsEnabled: () => boolean;
    connectionString: string;
}
const aiConfig: AppInsightsConfig = window['AppInsights'] || {analyticsEnabled: () => false, connectionString: ''};
let appInsights;
if(aiConfig.analyticsEnabled()) {
    appInsights = new ApplicationInsights({
        config: {
            connectionString: aiConfig.connectionString,
            disableFetchTracking: false
        }
    });
    appInsights.loadAppInsights();
    appInsights.trackPageView();
    // eslint-disable-next-line no-console
    console.info('Analytics reporting enabled');
}
else {
    // eslint-disable-next-line no-console
    console.warn('Analytics reporting disabled');
}

export default (appInsights as IApplicationInsights);
